document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector("footer.footer-sections");

  const targetDiv = document.querySelector(".product-page-footer");

  if (footer && targetDiv) {
    targetDiv.innerHTML = footer.outerHTML; // append as innerHTML

    targetDiv.style.visibility = "visible"; // make visible after append
  } else {
    console.error("Footer or target div not found.");
  }
});

$(document).ready(function () {
  $(".custom-tableforSize tr:even, .custom-tableforSize table").addClass(
    "swatches"
  );

  console.log("Starting to build colorInventories dictionary.");
  var colorInventories = {};

  $(".all-product-variants [data-option1]").each(function () {
    var color = $(this).data("option1").toString().toUpperCase();
    console.log("Found color:", color);

    var inventoryValue = parseInt($(this).data("inventory"), 10) || 0;
    console.log(
      "Raw inventory value:",
      $(this).data("inventory"),
      "Parsed inventory value:",
      inventoryValue
    );

    if (inventoryValue < 0) {
      inventoryValue = 0;
    }

    console.log("Inventory value after negative check:", inventoryValue);

    if (!colorInventories[color]) {
      colorInventories[color] = 0;
    }
    colorInventories[color] += inventoryValue;
    console.log("Updated total for", color, "=", colorInventories[color]);
  });

  console.log("Final colorInventories object:", colorInventories);

  for (var colorKey in colorInventories) {
    var totalInv = colorInventories[colorKey];
    console.log("Color Key:", colorKey, "Total Inventory:", totalInv);

    var $radio = $(
      '[data-option-type="Color"] input[value="' + colorKey + '"]'
    );
    console.log("Matching radio input(s):", $radio);

    if ($radio.length) {
      $radio.attr("data-total-inventory", totalInv);
      console.log(
        "Set data-total-inventory to",
        totalInv,
        "for color:",
        colorKey
      );

      if (totalInv === 0) {
        $radio.addClass("not-available-based-on-sizes");
        console.log("Added 'not-available-based-on-sizes' to", colorKey);
      } else {
        $radio.removeClass("not-available-based-on-sizes");
        console.log("Removed 'not-available-based-on-sizes' from", colorKey);
      }
    } else {
      console.log("No radio input found with value =", colorKey);
    }
  }

  console.log("Done assigning data-total-inventory attributes and classes.");

  function sizeTotalUpdate() {
    var selectedValue = $(
      '[data-option-type="Color"] input[type="radio"]:checked'
    )
      .val()
      .toLowerCase();

    console.log(selectedValue + "Selected Color");
    $("p.honey-message").text(selectedValue);
    var modifiedValue = selectedValue.replace(/\s+/g, "-");

    $.ajax({
      url: window.location.href,
      success: function (response) {
        var updatedContent = $(response).find("product-images").html();
        setTimeout(function () {
          $(".product__slide, .product__thumb").each(function () {
            if ($(this).data("color") !== modifiedValue) {
              $(this).remove();
            }
          });
        }, 100);

        $("product-images").html(updatedContent);
        $("product-images").css("opacity", "1");
        $("product-images").css("visibility", "visible");

        function setupDragScroll(
          containerSelector,
          contentSelector,
          sensitivity = 1
        ) {
          const container = document.querySelector(containerSelector);
          const content = document.querySelector(contentSelector);
          let isDragging = false;
          let startX;
          let scrollLeft;

          container.addEventListener("mousedown", (e) => {
            isDragging = true;
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
          });

          container.addEventListener("mouseleave", () => {
            isDragging = false;
          });

          container.addEventListener("mouseup", () => {
            isDragging = false;
          });

          container.addEventListener("mousemove", (e) => {
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            // Adjust the walk by the sensitivity factor
            const walk = (x - startX) * sensitivity; // Modify this line
            container.scrollLeft = scrollLeft - walk;
          });
        }

        setupDragScroll(".product__slides", ".product__slide", 3.5); // Adjust the third parameter as needed

        // Add more carousels as needed, with their respective container and content selectors.
      },
      error: function (xhr, status, error) {
        console.error("Error refreshing content: " + error);
      },
    });

    $("tr.swatches").css("--swatch", "var(--" + modifiedValue + ")");
    $(".custom-tableforSize table").css(
      "--swatch",
      "var(--" + modifiedValue + ")"
    );

    //if the swatch color if white than inverse color of size tables
    if (modifiedValue === "off-white") {
      $("tr.swatches").css("color", "#000");
    } else {
      $("tr.swatches").css("color", "#fff");
    }
    var totalInventory = 0;

    // Iterate over elements with the specified data-option1 attribute
    $(".all-product-variants [data-option1]").each(function () {
      // Check if the data-option1 attribute matches the selected color
      if ($(this).data("option1").toLowerCase() === selectedValue) {
        // Get the inventory value
        var inventoryValue = parseInt($(this).data("inventory"), 10);
        // Treat negative values as 0
        if (inventoryValue < 0) {
          inventoryValue = 0;
        }
        // Add to the total
        totalInventory += inventoryValue;
      }
    });

    // Output the total inventory for the selected color
    console.log(
      totalInventory + " " + selectedValue + " Pieces remaining test"
    );

    $("#variant_total_num").html(
      totalInventory + " " + selectedValue + " Pieces"
    );
  }

  // On page load
  sizeTotalUpdate();

  // On input change
  $('[data-option-type="Color"] input[type="radio"]').change(function () {
    sizeTotalUpdate();
  });

  const variantName = $("#variant-name");
  const availableQuantity = $("#available-quantity");
  const inputElement = document.querySelector('input[name="id"]');

  function updateVariantName(value) {
    variantName.html(value);
  }

  function updateAvailableQuantity(value) {
    // Ensure the value is a non-negative number
    const newValue = Math.max(parseInt(value), 0);
    availableQuantity.html(newValue);
  }

  function handleInputChange() {
    const newValue = inputElement.value;
    const divElement = document.querySelector(`div[data-id="${newValue}"]`);

    // Define the HTML content as a constant
    const PREORDER_INSTRUCTION_HTML = `
    <span class="heading">PLEASE NOTE* OTHER COLORS & SIZES ARE STILL IN STOCK</span>
    <span class="description">This size & color is currently sold out, but we have a new batch of 10,000 pieces being made now and will be completed on Dec 27th — note* it will take 2-3 weeks for goods to arrive and ship. If you’d like to reserve a piece — you can pre-order below.</span>
  `;

    if (divElement) {
      const dataInventoryValue = parseInt(
        divElement.getAttribute("data-inventory")
      );
      console.log("Current variant inventory:", dataInventoryValue);

      // Update available quantity
      updateAvailableQuantity(dataInventoryValue);

      // Get the button text element and the parent container
      const buttonTextElement = document.querySelector(
        ".Preorder-btn-overide-pdp .btn__text"
      );
      const preorderContainer = document.querySelector(
        ".Preorder-btn-overide-pdp"
      );

      // Get the instruction div
      const preorderInstruction = document.querySelector(
        ".preorder-instruction-pdp"
      );

      // Replace "Add to Bag" with "Pre-order Jan 15 Batch" if inventory is 0 or negative
      if (dataInventoryValue <= 0) {
        buttonTextElement.textContent = "Pre-order Dec 27th Batch";

        // Add a class to the parent container
        preorderContainer.classList.add("preorder-active");

        // Update the text in the instruction div
        if (preorderInstruction) {
          preorderInstruction.innerHTML = PREORDER_INSTRUCTION_HTML;
        }
      } else {
        buttonTextElement.textContent = "Add to Bag";

        // Remove the class if inventory is positive
        preorderContainer.classList.remove("preorder-active");

        // Clear the text in the instruction div
        if (preorderInstruction) {
          preorderInstruction.innerHTML = "";
        }
      }
    } else {
      console.log("Element with the specified data-id not found.");
    }
  }

  $('[data-option-type="Size"] input[type="radio"]').on("change", function () {
    if ($(this).is(":checked")) {
      console.log("Selected value: " + $(this).val());
      updateVariantName($(this).val());
    }
  });

  // Initial setup
  const initialVal = $(
    '[data-option-type="Size"] input[type="radio"]:checked'
  ).val(); // Ensure you get the value of the checked radio button
  updateVariantName(initialVal); // Update the variant name initially
  handleInputChange();

  const observer = new MutationObserver(function (mutationsList) {
    handleInputChange();
  });

  observer.observe(inputElement, { attributes: true });

  const inventoryDivs = document.querySelectorAll("div[inventorymanagment]");
  let totalSum = 0;

  inventoryDivs.forEach((div) => {
    const inventoryValue = parseInt(div.getAttribute("data-inventory"));
    totalSum += inventoryValue;
  });

  $("#total-inv-number").html(totalSum);
  console.log("Total Inventory:", totalSum);
});

